module.exports = __webpack_public_path__ + "img/dr_cn.9a31146a.png";